import {observer} from "mobx-react";
import {
    DialogStore,
    slsCustomerStore,
    slsDetailStore,
    slsPrinterStore,
    slsUserStore,
    validationStore
} from "../../../store";
import {SlsForm, SlsFormValidation} from "./SlsForm";
import {FieldAutoComplete, FieldSelect, ModalDialog, Page, PageContentTitle} from "../../ui";
import {useState} from "react";
import {DialogAction} from "@kroschke/react-ui";
import {convertPlacementProcessStatus} from "../../../api";

const SlsDetailPage = observer(function SlsDetailPage() {
    const [cabinetSelectDialog] = useState(new DialogStore())

    const validation: SlsFormValidation = {
        correlationId: validationStore.getFor('correlationId'),
        customer: validationStore.getFor('customer') || validationStore.getFor('customerId'),
        user: validationStore.getFor('user') || validationStore.getFor('userId')
    }


    const display = `${slsDetailStore.correlationId || ''} (${convertPlacementProcessStatus(slsDetailStore.status)})`
    const cabinetOptions = slsDetailStore.cabinets.map(cabinet => ({
        value: cabinet,
        label: cabinet
    }))

    const dialogActions: DialogAction[] = [
        {
            label: "Abbrechen",
            execute: async function () {
                slsDetailStore.cabinet = undefined
                slsDetailStore.printer = undefined
                cabinetSelectDialog.dialogOpen = false
            },
            className: 'is-rounded is-small'
        }
    ]

    const cabinetsExist = Boolean(cabinetOptions.length)

    if ((slsDetailStore.cabinet || !cabinetsExist) && slsDetailStore.printer) {
        dialogActions.push({
            label: "Einlagerung abschließen",
            executing: cabinetSelectDialog.executing,
            execute: async function () {
                cabinetSelectDialog.executing = true
                await slsDetailStore.complete()
                cabinetSelectDialog.executing = false
                cabinetSelectDialog.dialogOpen = false
            },
            className: 'is-primary is-rounded is-small'
        })
    }

    return <Page
        breadcrumb={[
            {
                link: '/sls',
                label: 'Einlagerung'
            },
            {
                link: `/sls/${slsDetailStore.id}`,
                label: display
            }
        ]}
    >
        <ModalDialog
            titleCloseable={false}
            store={cabinetSelectDialog}
            actions={dialogActions}
            title={"Einlagerung abschließen"}
        >
            <div className={'columns'}>
                {cabinetsExist && <div className={'column is-half'}>
                    <FieldSelect
                        label={"Schrank"}
                        help={"Bitte wähle den zu verwendenden Schrank"}
                        options={cabinetOptions}
                        value={slsDetailStore.cabinet || ''}
                        onChange={v => {
                            slsDetailStore.cabinet = v
                        }}
                    />
                </div>}
                <div className={`column ${cabinetsExist ? 'is-half' : 'is-full'}`}>
                    <FieldAutoComplete
                        label={"Labeldrucker"}
                        help={"Bitte wähle den zu verwendenden Drucker"}
                        required={true}
                        itemRenderer={c => c.label}
                        options={slsPrinterStore.options}
                        search={async (v) => {
                            await slsPrinterStore.find(v)
                            return slsPrinterStore.options
                        }}
                        value={slsDetailStore.printer}
                        onChange={v => {
                            slsDetailStore.printer = v
                        }}
                    />
                </div>
            </div>
        </ModalDialog>

        <PageContentTitle
            actionItem={<>
                <button
                    className={`button is-primary is-rounded is-small
                    ${slsDetailStore.completableChecking || slsDetailStore.completing ? 'is-loading' : ''}`}
                    disabled={!slsDetailStore.completable ||
                        slsDetailStore.completableChecking || slsDetailStore.completing || slsDetailStore.isStorageTransfer}
                    onClick={async () => {
                        await slsPrinterStore.load()
                        cabinetSelectDialog.dialogOpen = true
                    }}
                >Einlagerung abschließen</button>
            </>}

        >{display}</PageContentTitle>
        <SlsForm
            validation={validation}
            customers={slsCustomerStore.items}
            users={slsUserStore.items}
            data={slsDetailStore.formData}
            onChange={data => slsDetailStore.formData = data}
            onBlur={() => slsDetailStore.validate()}
            disabled={true}
            mode={'update'}
            onSearchCustomer={async (query) => await slsCustomerStore.search(query)}
            onSearchUser={async (query) => await slsUserStore.search(query)}
            onRemovePlacementProcessDocument={(documentId) => {slsDetailStore.removeDocument(documentId)}}
        />
    </Page>
})

export {
    SlsDetailPage
}
